<template>
	<div class="add-payment-method-popup" >

		<fpay-groups-popup v-if="step==='select-group'" :groups="groups" :funnel="funnel" :loading="loading" @close="closePopup" @groupClicked="groupClicked" />

		<fpay-group-gateways-popup v-if="step==='select-gateways'" :groups="groups" @close="closePopup"
		                           @editUserGateway="editUserGateway($event)" @gatewayClicked="gatewayClicked"
		                           :current-group="currentGroup" @addNew="step='create'" @goBack="step='select-group'"  />

		<fpay-new-user-gateway-popup v-if="step==='create'" :groups="groups" :current-group="currentGroup"
		                             @close="closePopup" @goBack="step='select-gateways'"  />

		<fpay-edit-user-gateway-popup v-if="step==='edit'" :groups="groups" :current-group="currentGroup"
		                              :userGateway="currentUserGateway"
		                             @close="closePopup" @goBack="step='select-gateways'"  />

	</div>
</template>

<script>
import API from "@/api"
import FpayGroupsPopup from "@/views/funnels/apps/funnel-apps/fpay/fpay-groups-popup";
import FpayGroupGatewaysPopup from "@/views/funnels/apps/funnel-apps/fpay/fpay-group-gateways-popup";
import FpayNewUserGatewayPopup from "@/views/funnels/apps/funnel-apps/fpay/fpay-new-user-gateway-popup";
import FpayEditUserGatewayPopup from "@/views/funnels/apps/funnel-apps/fpay/fpay-edit-user-gateway-popup";

export default {
    name: "AddPaymentMethodPopup",
    components: {
	    FpayEditUserGatewayPopup,
	    FpayNewUserGatewayPopup,
	    FpayGroupGatewaysPopup,
	    FpayGroupsPopup,
    },
    mixins: [API],
	props:['funnel','currentPaymentMethod'],
    data: function() {
        return {
	        step: 'select-group', // or select-gateway or edit
	        loading: false,
	        currentGroup: null,
	        currentGroupId: 0,
	        groups: [],
	        gatewayId: 0,
	        creatingNew: false,
	        currentGateway: {},
	        currentUserGateway: null,
        };
    },
    computed: {
    },
    methods: {
	    gatewayClicked(userGateway) {
				this.$emit('gatewayClicked', userGateway);
	    },
	    editUserGateway(userGateway) {
	    	this.step = 'edit';
	    	this.currentUserGateway = userGateway;
	    },
	    groupClicked(group) {
		    this.currentGroup = group;
		    this.step = 'select-gateways';
	    },
	    closePopup() {
		    this.$emit("close");
	    },
      async init() {
    		try {
			    this.loading = true;
    			let g = await this.getPaymentMethods();
			    this.groups = g.data;

					// if there is a current payment method then select it.
					if (this.currentPaymentMethod) {
						let m = this.currentPaymentMethod;
						let g = this.groups.find(x=>x.id===m.group_id)
						if (g) {
							this.currentGroup = g;
							let ug = g.user_gateways.find(x=>x.id===m.user_gateway_id)
							this.step = "edit";
							this.currentUserGateway = ug;
						}
					}
		    }catch (e) {
			    console.error("error", e);
		    } finally {
			    this.loading = false;
		    }
      },
    },
    mounted() {
        this.init()
    }
}
</script>
<style lang="scss" >
.add-payment-method-popup {
	.content {
		padding: 0 10px 6px;
		height: 100%;
		display: flex;
		flex-direction: column;
		overflow: auto;
	}
	.popup{
		max-width: 680px;
	}
}
</style>
